import React from 'react';
import get from 'lodash/get';
import map from 'lodash/map';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import BusinessHours from 'src/models/BusinessHours/BusinessHours';
import EmbedModal, { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { BusinessHoursReferenceLink } from 'src/presentation/components/pages/businessHours/hooks/useShowReferences';

type BusinessHoursReferencesModalProps = {
  item?: BusinessHours;
  onCancel: () => void;
  references?: BusinessHoursReferenceLink[];
};

const BusinessHoursReferencesModal = ({ item, onCancel, references }: BusinessHoursReferencesModalProps) => {
  const linksList = map(references, (reference: BusinessHoursReferenceLink, idx: number) => (
    <Link
      data-aid={`reference-${reference.type}-${reference.id}`}
      to={reference.link}
      target="_blank"
      key={`reference-${idx}`}
    >
      {reference.name}
    </Link>
  ));

  const context = <LinksContainer data-aid="references-container">{linksList}</LinksContainer>;

  return (
    <StyledEmbedModal
      data-aid="business-hours-references-modal"
      title={`${get(item, 'name')} is used in...`}
      content={context}
      onCancel={onCancel}
      modalSize={ModalSize.LARGE}
    />
  );
};

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 162%;
`;

const StyledEmbedModal = styled(EmbedModal)`
  .Modal-backdrop {
    background-color: ${p => p.theme.colors.white};
    opacity: 0.8;
  }

  .modalCard-content {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
    padding: 18px 45px;
  }
`;

export default BusinessHoursReferencesModal;
